import { useEffect, useState } from "react";
import { questionnaireApi } from "../../data/api/QuestionnaireApi";
import { QuestionnaireUserItem } from "../../data/models/Questionnaire/QuestionnaireModel";

export function useQuestionnaires() {
  const [questionnaires, setQuestionnaires] = useState<QuestionnaireUserItem[]>(
    [],
  );
  const [loading, setLoading] = useState(true);

  const fetchQuestionnaires = async () => {
    setLoading(true);
    try {
      const result = await questionnaireApi.assignedQuestionnaires.request(null);
      setQuestionnaires(
        result.isSuccess && Array.isArray(result.data) ? result.data : [],
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchQuestionnaires();
  }, []);

  return {
    questionnaires,
    loading,
    refreshQuestionnaires: fetchQuestionnaires,
  };
}
